import { appName } from '#app/utils/constants.js'
import { Logo } from '../components/custom/logo'
import { Container } from '../components/verveui/layout/container'

export const Footer = () => {
	const navigation = {
		social: [
			{
				name: 'YouTube',
				href: 'https://www.youtube.com/@EstudaComigo-w3f/videos',
				icon: (props: any) => (
					<svg fill="currentColor" viewBox="0 0 24 24" {...props}>
						<path
							fillRule="evenodd"
							d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
							clipRule="evenodd"
						/>
					</svg>
				),
			},
		],
	}
	return (
		<Container>
			<footer className="pb-5 pt-10">
				<h2 id="footer-heading" className="sr-only">
					Footer
				</h2>
				<div className="xl:grid xl:grid-cols-3 xl:gap-8">
					<div className="space-y-8">
						<Logo />
						<div className="flex space-x-6">
							{navigation.social.map(item => (
								<a
									key={item.name}
									href={item.href}
									className="text-muted-500 hover:text-muted-600"
								>
									<span className="sr-only">{item.name}</span>
									<item.icon aria-hidden="true" className="h-6 w-6" />
								</a>
							))}
						</div>
					</div>
				</div>
				<div className="border-foreground/10 mt-16 border-t dark:border-muted-300 pt-8 sm:mt-20 lg:mt-24">
					<div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
						<p className="text-xs leading-5 text-muted-600">
							&copy; {new Date().getFullYear()} {appName}, Inc. All rights
							reserved.
						</p>
						<p className="text-xs leading-5 text-muted-600">
							<a
								href="https://casalinnovations.com/"
								className="hover:text-muted-800 underline-offset-2 hover:underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								Desenvolvido por Casal Innovations
							</a>
						</p>
					</div>
				</div>
			</footer>
		</Container>
	)
}
